<template>
  <div class="top barging-container">
    <div class="flex flex-row justify-between p-1 laptop:pb-2 desktop:pb-4">
      <tabs :tabs="tabsList" @updateIndex="updateIndex" :currentIndex="upIndex"></tabs>
    </div>

    <div class="barging-card" style="padding:0px 0px; margin-top:0px; background-color:#f2f7fa; border-radius: 10px;">
      <!-- search bar multiple row in mobile view -->
      <div class="w-full searchBar" id="shipVettBar" ref="shipVettSearchBarRef" v-show="true">
        <div class="flex flex-wrap justify-end">
          <div class="flex flex-row py-2 pr-1" v-if="!(this.userInfo.role == 4 || this.userInfo.role == 5)">
            <el-date-picker v-model="params.sireDate" size="mini" start-placeholder="Sire Start Date"
              end-placeholder="Sire End Date" prefix-icon="el-icon-date" type="daterange" :style="{ width: '230px' }"
              format="yyyy-MM-dd" value-format="yyyy-MM-dd">
            </el-date-picker>
          </div>

          <div class="flex flex-row py-2 pr-1" v-if="!(this.userInfo.role == 4 || this.userInfo.role == 5)">
            <el-date-picker v-model="params.utDate" size="mini" start-placeholder="UT Start Date"
              end-placeholder="UT End Date" prefix-icon="el-icon-date" type="daterange" :style="{ width: '220px' }"
              format="yyyy-MM-dd" value-format="yyyy-MM-dd">
            </el-date-picker>
          </div>

          <div class="flex flex-row py-2 pr-1" v-if="!(this.userInfo.role == 4 || this.userInfo.role == 5)">
            <el-date-picker v-model="params.rejectedDate" size="mini" start-placeholder="Rejected Start Time"
              end-placeholder="Rejected End Time" prefix-icon="el-icon-date" type="datetimerange"
              :style="{ width: '320px' }" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"
              :default-time="['00:00:00', '23:59:59']" @change="handleDateChange" />
          </div>

          <div class="flex flex-row py-2 pr-1" v-if="!(this.userInfo.role == 4 || this.userInfo.role == 5)">
            <el-date-picker v-model="params.acceptedDate" size="mini" start-placeholder="Accepted Start Time"
              end-placeholder="Accepted End Time" prefix-icon="el-icon-date" type="datetimerange"
              :style="{ width: '320px' }" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"
              :default-time="['00:00:00', '23:59:59']" @change="handleDateChange" />
          </div>

          <div class="flex flex-row py-2 pr-1" v-if="!(this.userInfo.role == 4 || this.userInfo.role == 5)">
            <el-select v-model="params.companyStatus" size="mini" multiple @change="handleSelectChange"
              :style="{ maxHeight: '100px', overflowY: 'scroll', width: '300px' }">
              <el-option v-for="status in tabsList" :key="status.index" :label="status.label" :value="status.label">
              </el-option>
            </el-select>
          </div>

          <div class="flex flex-row py-2 pr-1">
            <el-input v-model="params.searchValue" size="mini" clearable placeholder="Search IMO/Name"
              :style="{ width: '100%' }">
            </el-input>
          </div>

          <div class="flex flex-row pl-1 py-2">
            <el-button size="mini" type="primary" @click="getList">Search</el-button>
            <el-button size="mini" type="primary" v-if="userInfo.role != 13 && userInfo.role != 16"
              @click="handleCreateNewShip">
              {{ (this.userInfo.role == 4 || this.userInfo.role == 5) ? "Create a New Request" : "Create a New Ship" }}
            </el-button>
          </div>
        </div>
      </div>

      <!-- normal table for non-anchorage tabs -->
      <div v-if="!showAnchorageGroupedView" class="box-card barging-table"
        v-bind:class="{ 'mobile-view': isMobileScreen }">
        <div class="w-full Comtable" id="shipVettTable" ref="shipVettTableRef">
          <el-table key="shipVettingList" :data="listData" :header-cell-style="tableHeaderStyle"
            :cell-style="getCellStyle" @row-click="handleTableRowClick" table-layout="auto" height="100%">
            <el-table-column align="left" prop="imo" label="IMO" min-width="100"></el-table-column>

            <el-table-column align="left" prop="shipName" label="Ship Name" min-width="200">
              <template slot-scope="scope">
                {{ (scope.row.shipName || "").toUpperCase() }}
              </template>
            </el-table-column>

            <el-table-column align="left" prop="age" label="Age" min-width="80"></el-table-column>

            <el-table-column align="left" prop="sireDocumentDate" label="SIRE Document Date" min-width="150"
              v-if="!(this.userInfo.role == 4 || this.userInfo.role == 5)">
            </el-table-column>

            <el-table-column v-if="!(this.userInfo.role == 4 || this.userInfo.role == 5)" align="left"
              prop="utObservationDate" label="UT Observation Date" min-width="150" :formatter="formatCompleteTime">
            </el-table-column>

            <el-table-column align="left" prop="shipStatus" label="Ship Status" min-width="200">
              <template slot-scope="scope">
                <div :style="getShipStatusStyle(scope.row.shipStatus || scope.row.status)">
                  {{ getShipVettingStatus(scope.row.shipStatus || scope.row.status) }}
                </div>
              </template>
            </el-table-column>

            <el-table-column v-if="!(this.userInfo.role == 4 || this.userInfo.role == 5)" align="left"
              prop="customerVettingInfo" label="Company Status" min-width="360">
              <template slot-scope="scope">
                <div v-for="info in scope.row.customerVettingInfo" :key="info.companyName">
                  <span>{{ info.companyName }}: </span>
                  <span :style="getCompanyStatusStyle(info.status)">
                    {{ getShipVettingStatus(info.status) }}
                  </span>
                  <span v-if="[5, 6].includes(info.status) && (info.rejectTime || info.acceptTime)">
                    on {{ getStatusDate(info, info.status) }}
                  </span>
                </div>
              </template>
            </el-table-column>

            <el-table-column v-if="(!(this.userInfo.role == 4 || this.userInfo.role == 5))" align="left"
              prop="customerVettingInfo" label="Rejected Remarks" min-width="300">
              <template slot-scope="scope">
                <div v-for="info in scope.row.customerVettingInfo" :key="info.companyName">
                  <span v-if="info.rejectRemark">{{ info.companyName }}: </span>
                  <span>{{ info.rejectRemark }}</span>
                </div>
              </template>
            </el-table-column>

            <el-table-column v-if="this.userInfo.userType == 2 && upIndex == '5'" align="left" prop="rejectTime"
              label="Rejected Date" min-width="180">
            </el-table-column>

            <el-table-column v-if="this.userInfo.userType == 2 && upIndex == '5'" align="left" prop="terminalRemarks"
              label="Rejected Remark" min-width="180">
            </el-table-column>

            <el-table-column v-if="this.userInfo.userType == 2 && upIndex == '6'" align="left" prop="acceptTime"
              label="Accepted Date" min-width="180">
            </el-table-column>

            <el-table-column align="left" prop="createBy" label="Created by" min-width="150"
              v-if="userInfo.role == 1 || userInfo.role == 13">
            </el-table-column>

            <el-table-column align="left" prop="action" label="Action" min-width="850" v-if="userInfo.role == 1">
              <template slot-scope="scope">
                <el-button size="mini" type="success" plain v-if="[1, 3].includes(scope.row.shipStatus)"
                  @click.stop="handleStatusButtonClick(scope.row.id, 6)">
                  Accept
                </el-button>

                <el-button size="mini" type="danger" plain v-if="[1, 3].includes(scope.row.shipStatus)"
                  @click.stop="handleStatusButtonClick(scope.row.id, 5)">
                  Reject
                </el-button>

                <el-button size="mini" type="primary" plain v-if="[1].includes(scope.row.shipStatus)"
                  @click.stop="handleStatusButtonClick(scope.row.id, 2)">
                  Submit for Inspection
                </el-button>

                <el-button size="mini" type="primary" plain v-if="[1, 3].includes(scope.row.shipStatus)"
                  @click.stop="handleStatusButtonClick(scope.row.id, 4)">
                  Anchorage Inspection
                </el-button>

                <el-button size="mini" type="primary" plain v-if="[1, 3].includes(scope.row.shipStatus)"
                  @click.stop="handleMoreInfoRequired(scope.row.id, 8)">
                  More Information Required
                </el-button>

                <el-button size="mini" type="primary" plain v-if="[1, 3].includes(scope.row.shipStatus)"
                  @click.stop="handleSuspended(scope.row.id, 10)">
                  Suspend
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>

      <!-- grouped anchorage view -->
      <div v-else class="box-card barging-table anchorage-grouped-container"
        v-bind:class="{ 'mobile-view': isMobileScreen }">
        <div class="w-full Comtable anchorage-grouped-table" id="shipVettTable" ref="shipVettTableRef">
          <el-collapse v-model="activeAnchorageSections" class="anchorage-collapse">
            <el-collapse-item name="7days">
              <template slot="title">
                <div class="anchorage-collapse-title">7 days</div>
              </template>

              <div class="anchorage-section-body">
                <el-table :data="anchorageSevenDaysData" :header-cell-style="tableHeaderStyle"
                  :cell-style="getCellStyle" @row-click="handleTableRowClick" table-layout="auto"
                  :height="anchorageSevenDaysData.length ? undefined : 470" style="overflow-y: scroll;">
                  <el-table-column align="left" prop="imo" label="IMO" min-width="100"></el-table-column>

                  <el-table-column align="left" prop="shipName" label="Ship Name" min-width="200">
                    <template slot-scope="scope">
                      {{ (scope.row.shipName || "").toUpperCase() }}
                    </template>
                  </el-table-column>

                  <el-table-column align="left" prop="age" label="Age" min-width="80"></el-table-column>

                  <el-table-column align="left" prop="sireDocumentDate" label="SIRE Document Date" min-width="150"
                    v-if="!(this.userInfo.role == 4 || this.userInfo.role == 5)">
                  </el-table-column>

                  <el-table-column v-if="!(this.userInfo.role == 4 || this.userInfo.role == 5)" align="left"
                    prop="utObservationDate" label="UT Observation Date" min-width="150"
                    :formatter="formatCompleteTime">
                  </el-table-column>

                  <el-table-column align="left" prop="shipStatus" label="Ship Status" min-width="200">
                    <template slot-scope="scope">
                      <div :style="getShipStatusStyle(scope.row.shipStatus || scope.row.status)">
                        {{ getShipVettingStatus(scope.row.shipStatus || scope.row.status) }}
                      </div>
                    </template>
                  </el-table-column>

                  <el-table-column v-if="!(this.userInfo.role == 4 || this.userInfo.role == 5)" align="left"
                    prop="customerVettingInfo" label="Company Status" min-width="360">
                    <template slot-scope="scope">
                      <div v-for="info in scope.row.customerVettingInfo" :key="info.companyName">
                        <span>{{ info.companyName }}: </span>
                        <span :style="getCompanyStatusStyle(info.status)">
                          {{ getShipVettingStatus(info.status) }}
                        </span>
                        <span v-if="[5, 6].includes(info.status) && (info.rejectTime || info.acceptTime)">
                          on {{ getStatusDate(info, info.status) }}
                        </span>
                      </div>
                    </template>
                  </el-table-column>

                  <el-table-column v-if="(!(this.userInfo.role == 4 || this.userInfo.role == 5))" align="left"
                    prop="customerVettingInfo" label="Rejected Remarks" min-width="300">
                    <template slot-scope="scope">
                      <div v-for="info in scope.row.customerVettingInfo" :key="info.companyName">
                        <span v-if="info.rejectRemark">{{ info.companyName }}: </span>
                        <span>{{ info.rejectRemark }}</span>
                      </div>
                    </template>
                  </el-table-column>

                  <el-table-column v-if="this.userInfo.userType == 2 && upIndex == '5'" align="left" prop="rejectTime"
                    label="Rejected Date" min-width="180">
                  </el-table-column>

                  <el-table-column v-if="this.userInfo.userType == 2 && upIndex == '5'" align="left"
                    prop="terminalRemarks" label="Rejected Remark" min-width="180">
                  </el-table-column>

                  <el-table-column v-if="this.userInfo.userType == 2 && upIndex == '6'" align="left" prop="acceptTime"
                    label="Accepted Date" min-width="180">
                  </el-table-column>

                  <el-table-column align="left" prop="createBy" label="Created by" min-width="150"
                    v-if="userInfo.role == 1 || userInfo.role == 13">
                  </el-table-column>

                  <el-table-column align="left" prop="action" label="Action" min-width="850" v-if="userInfo.role == 1">
                    <template slot-scope="scope">
                      <el-button size="mini" type="success" plain v-if="[1, 3].includes(scope.row.shipStatus)"
                        @click.stop="handleStatusButtonClick(scope.row.id, 6)">
                        Accept
                      </el-button>

                      <el-button size="mini" type="danger" plain v-if="[1, 3].includes(scope.row.shipStatus)"
                        @click.stop="handleStatusButtonClick(scope.row.id, 5)">
                        Reject
                      </el-button>

                      <el-button size="mini" type="primary" plain v-if="[1].includes(scope.row.shipStatus)"
                        @click.stop="handleStatusButtonClick(scope.row.id, 2)">
                        Submit for Inspection
                      </el-button>

                      <el-button size="mini" type="primary" plain v-if="[1, 3].includes(scope.row.shipStatus)"
                        @click.stop="handleStatusButtonClick(scope.row.id, 4)">
                        Anchorage Inspection
                      </el-button>

                      <el-button size="mini" type="primary" plain v-if="[1, 3].includes(scope.row.shipStatus)"
                        @click.stop="handleMoreInfoRequired(scope.row.id, 8)">
                        More Information Required
                      </el-button>

                      <el-button size="mini" type="primary" plain v-if="[1, 3].includes(scope.row.shipStatus)"
                        @click.stop="handleSuspended(scope.row.id, 10)">
                        Suspend
                      </el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </el-collapse-item>

            <el-collapse-item name="others">
              <template slot="title">
                <div class="anchorage-collapse-title">Others</div>
              </template>

              <div class="anchorage-section-body">
                <el-table :data="anchorageOthersData" :header-cell-style="tableHeaderStyle" :cell-style="getCellStyle"
                  @row-click="handleTableRowClick" table-layout="auto"
                  :height="anchorageOthersData.length ? undefined : 470" style="overflow-y: scroll;">
                  <el-table-column align="left" prop="imo" label="IMO" min-width="100"></el-table-column>

                  <el-table-column align="left" prop="shipName" label="Ship Name" min-width="200">
                    <template slot-scope="scope">
                      {{ (scope.row.shipName || "").toUpperCase() }}
                    </template>
                  </el-table-column>

                  <el-table-column align="left" prop="age" label="Age" min-width="80"></el-table-column>

                  <el-table-column align="left" prop="sireDocumentDate" label="SIRE Document Date" min-width="150"
                    v-if="!(this.userInfo.role == 4 || this.userInfo.role == 5)">
                  </el-table-column>

                  <el-table-column v-if="!(this.userInfo.role == 4 || this.userInfo.role == 5)" align="left"
                    prop="utObservationDate" label="UT Observation Date" min-width="150"
                    :formatter="formatCompleteTime">
                  </el-table-column>

                  <el-table-column align="left" prop="shipStatus" label="Ship Status" min-width="200">
                    <template slot-scope="scope">
                      <div :style="getShipStatusStyle(scope.row.shipStatus || scope.row.status)">
                        {{ getShipVettingStatus(scope.row.shipStatus || scope.row.status) }}
                      </div>
                    </template>
                  </el-table-column>

                  <el-table-column v-if="!(this.userInfo.role == 4 || this.userInfo.role == 5)" align="left"
                    prop="customerVettingInfo" label="Company Status" min-width="360">
                    <template slot-scope="scope">
                      <div v-for="info in scope.row.customerVettingInfo" :key="info.companyName">
                        <span>{{ info.companyName }}: </span>
                        <span :style="getCompanyStatusStyle(info.status)">
                          {{ getShipVettingStatus(info.status) }}
                        </span>
                        <span v-if="[5, 6].includes(info.status) && (info.rejectTime || info.acceptTime)">
                          on {{ getStatusDate(info, info.status) }}
                        </span>
                      </div>
                    </template>
                  </el-table-column>

                  <el-table-column v-if="(!(this.userInfo.role == 4 || this.userInfo.role == 5))" align="left"
                    prop="customerVettingInfo" label="Rejected Remarks" min-width="300">
                    <template slot-scope="scope">
                      <div v-for="info in scope.row.customerVettingInfo" :key="info.companyName">
                        <span v-if="info.rejectRemark">{{ info.companyName }}: </span>
                        <span>{{ info.rejectRemark }}</span>
                      </div>
                    </template>
                  </el-table-column>

                  <el-table-column v-if="this.userInfo.userType == 2 && upIndex == '5'" align="left" prop="rejectTime"
                    label="Rejected Date" min-width="180">
                  </el-table-column>

                  <el-table-column v-if="this.userInfo.userType == 2 && upIndex == '5'" align="left"
                    prop="terminalRemarks" label="Rejected Remark" min-width="180">
                  </el-table-column>

                  <el-table-column v-if="this.userInfo.userType == 2 && upIndex == '6'" align="left" prop="acceptTime"
                    label="Accepted Date" min-width="180">
                  </el-table-column>

                  <el-table-column align="left" prop="createBy" label="Created by" min-width="150"
                    v-if="userInfo.role == 1 || userInfo.role == 13">
                  </el-table-column>

                  <el-table-column align="left" prop="action" label="Action" min-width="850" v-if="userInfo.role == 1">
                    <template slot-scope="scope">
                      <el-button size="mini" type="success" plain v-if="[1, 3].includes(scope.row.shipStatus)"
                        @click.stop="handleStatusButtonClick(scope.row.id, 6)">
                        Accept
                      </el-button>

                      <el-button size="mini" type="danger" plain v-if="[1, 3].includes(scope.row.shipStatus)"
                        @click.stop="handleStatusButtonClick(scope.row.id, 5)">
                        Reject
                      </el-button>

                      <el-button size="mini" type="primary" plain v-if="[1].includes(scope.row.shipStatus)"
                        @click.stop="handleStatusButtonClick(scope.row.id, 2)">
                        Submit for Inspection
                      </el-button>

                      <el-button size="mini" type="primary" plain v-if="[1, 3].includes(scope.row.shipStatus)"
                        @click.stop="handleStatusButtonClick(scope.row.id, 4)">
                        Anchorage Inspection
                      </el-button>

                      <el-button size="mini" type="primary" plain v-if="[1, 3].includes(scope.row.shipStatus)"
                        @click.stop="handleMoreInfoRequired(scope.row.id, 8)">
                        More Information Required
                      </el-button>

                      <el-button size="mini" type="primary" plain v-if="[1, 3].includes(scope.row.shipStatus)"
                        @click.stop="handleSuspended(scope.row.id, 10)">
                        Suspend
                      </el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </el-collapse-item>
          </el-collapse>
        </div>
      </div>

      <div class="barging-pagination">
        <pagination v-show="showPagination" :total="total" :page.sync="params.pageNum" :limit.sync="params.pageSize"
          :pageSizes="[20, 30, 50, 100]" @pagination="getList">
        </pagination>
      </div>
    </div>

    <el-dialog title="More Information Required" :visible.sync="logisticsRemarksDialog"
      :width="isMobileScreen ? '100%' : '500px'" @click="resetLogisticsRemarksForm()">
      <div>
        <el-form label-width="auto" size="mini" label-position="top" ref="remarksForm">
          <el-form-item label="Please state the remark:" prop="logisticsRemarks">
            <el-input type="textarea" :autosize="{ minRows: 3 }" v-model="logisticsRemarks" clearable size="small"
              :style="{ width: '100%' }">
            </el-input>
          </el-form-item>
        </el-form>
      </div>
      <template #footer>
        <div class="dialog-footer">
          <el-button plain type="primary" size="mini" @click="resetLogisticsRemarksForm()">
            {{ $t("btn.close") }}
          </el-button>
          <el-button type="primary" size="mini" @click="handleStatusButtonClick(selectedRowID, 8)">
            {{ $t("btn.submit") }}
          </el-button>
        </div>
      </template>
    </el-dialog>

    <el-dialog title="Suspend Ship" :visible.sync="suspendedDialog" :width="isMobileScreen ? '100%' : '500px'"
      @close="resetSuspendedForm()">
      <div>
        <el-form label-width="auto" size="mini" label-position="left" ref="suspendedForm">
          <el-form-item label="Start Date" prop="suspendedStartDate">
            <el-date-picker v-model="suspendedStartDate" placeholder="Start Date" type="datetime"
              format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"
              :style="{ width: isMobileScreen ? '100%' : '300px' }" clearable />
          </el-form-item>
          <el-form-item label="End Date" prop="suspendedEndDate">
            <el-date-picker v-model="suspendedEndDate" placeholder="End Date" type="datetime"
              format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" default-time="23:59:59"
              :style="{ width: isMobileScreen ? '100%' : '300px' }" clearable />
          </el-form-item>
        </el-form>
      </div>
      <template #footer>
        <div class="dialog-footer">
          <el-button plain type="primary" size="mini" @click="resetSuspendedForm()">{{ $t("btn.close") }}</el-button>
          <el-button type="primary" size="mini" @click="handleStatusButtonClick(selectedRowID, 10)">{{ $t("btn.submit")
          }}</el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import tabs from "@/components/tabs.vue";
import {
  getShipVettingListCount,
  updateShipVettingRequestStatus,
  getUnseenDisclaimers,
  getShipVettingListAll,
  getShipVettingList,
  getCustomerReqCount
} from "@/services";
import PdfView from "@/components/common/pdf-view.vue";
import { mapState } from "vuex";
import { getShipVettingStatus } from "@/utils/constants";
import userInfo from "@/mixins/userInfo";

const ANCHORAGE_FILTER_UUID = "7bcfdca6-972d-4384-a7a8-31da73dea642";

export default {
  name: "ShipVettingList",
  components: { tabs, PdfView },
  data() {
    return {
      pageStatus: 0,
      tabsList: [],
      upIndex: 0,
      listData: [],
      searchValue: "",
      selectDate: "",
      pageParams: {
        pageNum: 1,
        pageSize: 20,
      },
      total: 0,
      startDate: "",
      endDate: "",
      params: {
        pageNum: 1,
        pageSize: 20,
        searchValue: null,
        sireDate: null,
        utDate: null,
        companyStatus: ["Pending Logistic", "Pending Observation"],
        rejectedDate: null,
        acceptedDate: null,
      },
      activeAnchorageSections: ["7days"],
      anchorageSevenDaysData: [],
      anchorageOthersData: [],
      logisticsRemarksDialog: false,
      logisticsRemarks: "",
      selectedRowID: "",
      suspendedDialog: false,
      suspendedStartDate: null,
      suspendedEndDate: null,
      shipVettingCount: 0,
      refreshInterval: null,
      anchorageSevenDaysTotal: 0,
      anchorageOthersTotal: 0,
    };
  },
  computed: {
    ...mapState(["locale", "userInfo", "screenType"]),
    isMobileScreen() {
      return this.screenType?.isMobileScreen ?? false;
    },
    showAnchorageGroupedView() {
      return String(this.upIndex) === "4" && !(this.userInfo.role == 4 || this.userInfo.role == 5);
    },
    showPagination() {
      return this.total > 0;
    },
    tableHeaderStyle() {
      return {
        height: "55px",
        background: "#fff",
        "border-bottom": "2px solid #D6D9E1",
      };
    }
  },
  beforeRouteLeave(to, from, next) {
    if (this.$refs.orderListRef) {
      this.$refs.orderListRef.handleStopRefresh();
    }
    next();
  },
  created() {
    this.upIndex = window.localStorage.getItem("upIndex") || 0;
    this.params.companyStatus = this.userInfo.role == 13 ? ["All"] : ["Pending Logistic", "Pending Observation"];
    this.getList();
  },
  watch: {
    activeAnchorageSections: {
      handler(val) {
        if (String(this.upIndex) !== "4") return;
        if (this.userInfo.role == 4 || this.userInfo.role == 5) return;

        const visibleSections = val || [];
        const show7Days = visibleSections.includes("7days");
        const showOthers = visibleSections.includes("others");

        if (show7Days && showOthers) {
          this.total = this.anchorageSevenDaysTotal + this.anchorageOthersTotal;
        } else if (show7Days) {
          this.total = this.anchorageSevenDaysTotal;
        } else if (showOthers) {
          this.total = this.anchorageOthersTotal;
        } else {
          this.total = 0;
        }
      },
      deep: true,
    },
  },
  mounted() {
    this.adjustHeight();
    window.addEventListener("resize", this.adjustHeight);
    this.fetchUnseenDisclaimers();
    this.startAutoRefresh();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.adjustHeight);
    this.stopAutoRefresh();
  },
  methods: {
    adjustHeight() {
      const referenceElement = document.getElementById("shipVettBar");
      const targetElement = document.getElementById("shipVettTable");
      const mobileLayout = window.innerWidth < 1025;
      const fullscreenLayout = window.innerWidth > 1440;

      if (referenceElement && targetElement) {
        const referenceHeight = referenceElement.offsetHeight;
        if (referenceHeight === 44) {
          targetElement.style.height = "calc(100vh - 220px)";
          if (fullscreenLayout) {
            targetElement.style.height = "calc(100vh - 230px)";
          }
        } else if (referenceHeight >= 80 && referenceHeight <= 90) {
          if (mobileLayout) {
            targetElement.style.height = "calc(100vh - 300px)";
          } else {
            targetElement.style.height = "calc(100vh - 280px)";
          }
        } else if (referenceHeight === 132) {
          targetElement.style.height = "calc(100vh - 340px)";
        } else if (referenceHeight === 176) {
          targetElement.style.height = "calc(100vh - 380px)";
        }
      }
    },

    updateIndex(index) {
      this.upIndex = index;
      this.params.pageNum = 1;
      window.localStorage.setItem("upIndex", index);
      this.getList();
    },

    handleSelectChange(selectedValues) {
      const lastSelected = selectedValues[selectedValues.length - 1];

      if (lastSelected === "All" || selectedValues.length == 0) {
        this.params.companyStatus = ["All"];
      } else {
        const filtered = selectedValues.filter((v) => v !== "All");
        this.params.companyStatus = filtered;
      }

      this.getList();
    },

    handleDateChange() {
      this.params.pageNum = 1;
      this.getList();
    },

    buildBaseListPayload() {
      let data = {
        ...this.params,
      };

      if (this.params.utDate) {
        data.startDateUt = this.params.utDate[0];
        data.endDateUt = this.params.utDate[1];
        delete data.utDate;
      }

      if (this.params.sireDate) {
        data.startDateSire = this.params.sireDate[0];
        data.endDateSire = this.params.sireDate[1];
        delete data.sireDate;
      }

      if (this.params.rejectedDate) {
        data.rejectTimeStart = this.params.rejectedDate[0];
        data.rejectTimeEnd = this.params.rejectedDate[1];
        delete data.rejectedDate;
      }

      if (this.params.acceptedDate) {
        data.acceptTimeStart = this.params.acceptedDate[0];
        data.acceptTimeEnd = this.params.acceptedDate[1];
        delete data.acceptedDate;
      }

      return data;
    },

    buildTabsList(resData) {
      const tabs = [
        { label: "All", count: resData.all, index: "0" },
        { label: "Pending Logistic", count: resData.pendingLogistics || 0, index: "1" },
        { label: "Accepted", count: resData.approved || 0, index: "6" },
        { label: "Rejected", count: resData.rejected || 0, index: "5" },
        { label: "Anchorage Inspection", count: resData.anchorageInspection || 0, index: "4" },
        { label: "More Info Required", count: resData.moreInfoRequired || 0, index: "8" },
        { label: "Pending Observation", count: resData.pendingObservation || 0, index: "7" },
        { label: "Expired", count: resData.expired || 0, index: "9" },
        { label: "Suspended", count: resData.suspended || 0, index: "10" },
      ];

      if (this.userInfo.role === "1" || this.userInfo.role === "13") {
        tabs.splice(2, 0,
          { label: "Pending Inspector", count: resData.pendingInspection || 0, index: "2" },
          { label: "Inspector Responded", count: resData.inspectorResponded || 0, index: "3" }
        );
      }

      return tabs;
    },

    getFormattedCompanyStatuses() {
      const comState = this.params.companyStatus
        .map((item) => this.tabsList.find((tab) => tab.label.trim() === item.trim())?.index)
        .filter((index) => index !== undefined)
        .join(",");

      return comState === "0" ? "" : comState;
    },

    async getAnchorageGroupedList(data) {
      const baseData = { ...data };

      // customer: still use base list only
      if (this.userInfo.role == 4 || this.userInfo.role == 5) {
        delete baseData.companyStatus;

        const res = await getShipVettingListAll({
          ...baseData,
          status: 4,
        });

        this.total = Number(res?.total || 0);
        this.listData = res?.rows || [];
        this.anchorageSevenDaysData = [];
        this.anchorageOthersData = [];
        this.anchorageSevenDaysTotal = 0;
        this.anchorageOthersTotal = 0;
        return;
      }

      const formattedComState = this.getFormattedCompanyStatuses();
      delete baseData.companyStatus;

      const [sevenDaysRes, othersRes] = await Promise.all([
        getShipVettingList({
          ...baseData,
          shipStatus: 4,
          companyStatuses: formattedComState ?? "",
          anchorageFilter: "7days",
        }),
        getShipVettingList({
          ...baseData,
          shipStatus: 4,
          companyStatuses: formattedComState ?? "",
          anchorageFilter: "others",
        }),
      ]);

      this.anchorageSevenDaysData = sevenDaysRes?.rows || [];
      this.anchorageOthersData = othersRes?.rows || [];

      this.anchorageSevenDaysTotal = Number(sevenDaysRes?.total || 0);
      this.anchorageOthersTotal = Number(othersRes?.total || 0);

      const visibleSections = this.activeAnchorageSections || [];
      const show7Days = visibleSections.includes("7days");
      const showOthers = visibleSections.includes("others");

      if (show7Days && showOthers) {
        this.total = this.anchorageSevenDaysTotal + this.anchorageOthersTotal;
      } else if (show7Days) {
        this.total = this.anchorageSevenDaysTotal;
      } else if (showOthers) {
        this.total = this.anchorageOthersTotal;
      } else {
        this.total = 0;
      }

      this.listData = [];
    },

    async getList() {
      const data = this.buildBaseListPayload();

      if (this.userInfo.role == 4 || this.userInfo.role == 5) {
        const res = await getCustomerReqCount();
        if (res.code == 200) {
          this.tabsList = [
            { label: "All", count: res.data.all, index: "0" },
            { label: "Pending Logistic", count: res.data.pendingLogistics || 0, index: "1" },
            { label: "Accepted", count: res.data.approved || 0, index: "6" },
            { label: "Rejected", count: res.data.rejected || 0, index: "5" },
            { label: "Anchorage Inspection", count: res.data.anchorageInspection || 0, index: "4" },
            { label: "More Info Required", count: res.data.moreInfoRequired || 0, index: "8" },
            { label: "Pending Observation", count: res.data.pendingObservation || 0, index: "7" },
            { label: "Expired", count: res.data.expired || 0, index: "9" },
            { label: "Suspended", count: res.data.suspended || 0, index: "10" },
          ];
        }

        delete data.companyStatus;

        getShipVettingListAll({
          ...data,
          status: this.upIndex == 0 ? "" : Number(this.upIndex),
        }).then((res) => {
          this.total = res.total;
          this.listData = res.rows;
          this.anchorageSevenDaysData = [];
          this.anchorageOthersData = [];
        });

        return;
      }

      getShipVettingListCount().then(async (res) => {
        if (res.code == 200) {
          this.tabsList = this.buildTabsList(res.data);

          if (String(this.upIndex) === "4") {
            await this.getAnchorageGroupedList(data);
            return;
          }

          const formattedComState = this.getFormattedCompanyStatuses();
          delete data.companyStatus;

          getShipVettingList({
            ...data,
            shipStatus: this.upIndex == 0 ? "" : Number(this.upIndex),
            companyStatuses: formattedComState ?? "",
          }).then((listRes) => {
            this.total = listRes.total;
            this.listData = listRes.rows;
            this.anchorageSevenDaysData = [];
            this.anchorageOthersData = [];
          });
        }
      });
    },

    getCellStyle({ rowIndex }) {
      if (rowIndex % 2 === 1) {
        return {
          backgroundColor: "rgba(255,255,255,0.2)",
        };
      }
      return {
        backgroundColor: "rgba(228,228,228,0.2)",
      };
    },

    getShipVettingStatus,

    getShipStatusStyle(status) {
      const statusColors = {
        5: { color: "red" },
        6: { color: "green" },
      };
      return statusColors[status] || { color: "" };
    },

    formatDateTime(v) {
      if (!v) return "";
      return String(v).replace("T", " ");
    },

    getStatusDate(row, status) {
      if (status === 5) return this.formatDateTime(row.rejectTime);
      if (status === 6) return this.formatDateTime(row.acceptTime);
      return "";
    },

    getCompanyStatusStyle(status) {
      const statusColors = {
        5: { color: "red" },
        6: { color: "green" },
      };
      return statusColors[status] || { color: "#F37E01" };
    },

    handleTableRowClick(row) {
      this.$router.push({
        path: "/ship-vetting/index",
        query: {
          id: row.id,
          imo: row.imo,
          pageStatus: 1,
        },
      });
      sessionStorage.setItem("pageStatus", 1);
    },

    handleCreateNewShip() {
      this.$router.push({
        path: "/ship-vetting/index",
        query: {
          pageStatus: 2,
        },
      });
      sessionStorage.setItem("pageStatus", 2);
    },

    startAutoRefresh() {
      this.stopAutoRefresh();
      this.refreshInterval = setInterval(() => {
        this.getList();
      }, 15000);
    },

    stopAutoRefresh() {
      if (this.refreshInterval) {
        clearInterval(this.refreshInterval);
        this.refreshInterval = null;
      }
    },

    async handleStatusButtonClick(id, status) {
      this.stopAutoRefresh();

      if (status == 10) {
        if (!this.suspendedStartDate || !this.suspendedEndDate) {
          this.$message.error("Start Date and End Date required");
          this.startAutoRefresh();
          return;
        }
        if (new Date(this.suspendedEndDate) < new Date(this.suspendedStartDate)) {
          this.$message.error("End Date must be after Start Date");
          this.startAutoRefresh();
          return;
        }
      }

      if (status == 8 && (!this.logisticsRemarks || this.logisticsRemarks.trim() == "")) {
        this.$message.error("Remark required");
        this.startAutoRefresh();
        return;
      }

      const params = { shipStatus: status };
      if (status == 8) params.remarks = this.logisticsRemarks;
      if (status == 10) {
        params.suspendedStart = this.suspendedStartDate;
        params.suspendedEnd = this.suspendedEndDate;
      }

      try {
        const res = await updateShipVettingRequestStatus(id, params);
        if (res.code == 200) {
          this.$message.success("Request status updated");
          await this.getList();
        }
      } finally {
        this.resetLogisticsRemarksForm();
        this.resetSuspendedForm();
        this.startAutoRefresh();
      }
    },

    handleMoreInfoRequired(id) {
      this.selectedRowID = id;
      this.logisticsRemarks = "";
      this.logisticsRemarksDialog = true;
    },

    handleDelete(id) { },

    resetLogisticsRemarksForm() {
      this.selectedRowID = null;
      this.logisticsRemarks = "";
      this.logisticsRemarksDialog = false;
    },

    handleSuspended(id) {
      this.selectedRowID = id;
      this.suspendedStartDate = null;
      this.suspendedEndDate = null;
      this.suspendedDialog = true;
    },

    resetSuspendedForm() {
      this.suspendedDialog = false;
      this.suspendedStartDate = null;
      this.suspendedEndDate = null;
    },

    formatCompleteTime(row, column, cellValue) {
      if (!cellValue) return "";
      return cellValue.replace("T", " ");
    },

    async fetchUnseenDisclaimers() {
      try {
        const resp = await getUnseenDisclaimers();
        const unseen = Array.isArray(resp.data) ? resp.data.length : 0;
        this.$root.shipVettingCount = unseen;
      } catch (e) {
        console.error("Unable to load unseen disclaimers", e);
      }
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep .shipname-uppercase .cell {
  text-transform: uppercase;
}

::v-deep {
  .el-input__icon.el-icon-search {
    height: 32px !important;
  }
}

::v-deep .pagination-container {
  background: #f2f7fa;
}

::v-deep .el-input__suffix-inner {
  padding-right: 5px;
  display: flex;
  justify-content: center;
  flex-direction: column;

  svg {
    width: 13px;
    height: 13px;
    cursor: pointer;
  }
}

::v-deep .el-table .cell {
  word-break: normal;
}

.searchBar {
  width: 100% !important;
  background-color: #f3f7fa;
  font-size: 11px;
  color: #1D1B20;
  font-family: 'Roboto';
  padding: 0px 10px 0px 10px;

  .label {
    padding: 5px;
    color: #1D1B20;
    font-weight: 600;
    text-align: right;
    width: 90px;
  }
}

.barging-container {
  border-radius: 10px;
}

.anchorage-grouped-container {
  background: #f2f7fa;
}

.anchorage-grouped-table {
  overflow: auto;
  background: #fff;
  border: 1px solid #dddddd;
}

.anchorage-collapse {
  border-top: none;
  border-bottom: none;
  background: #fff;
}

.anchorage-collapse-title {
  font-size: 16px;
  font-weight: 700;
  color: #7e7e7e;
  padding-left: 0;
}

.anchorage-section-body {
  padding: 0;
  background: #fff;
}

::v-deep .anchorage-collapse .el-collapse-item {
  margin: 0;
}

::v-deep .anchorage-collapse .el-collapse-item__header {
  height: 56px;
  line-height: 56px;
  background: #fff;
  padding: 0 16px;
  font-weight: 700;
  border-bottom: 1px solid #dddddd;
  border-top: none;
}

::v-deep .anchorage-collapse .el-collapse-item__wrap {
  border-bottom: 1px solid #dddddd;
  background: #fff;
}

::v-deep .anchorage-collapse .el-collapse-item__content {
  padding-bottom: 0;
  background: #fff;
  min-height: 300px;
}

::v-deep .anchorage-collapse .el-collapse-item__arrow {
  font-size: 18px;
  color: #111;
  margin-right: 0;
}

::v-deep .anchorage-grouped-table .el-table::before {
  display: none;
}
</style>